var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "566.929px",
    height: "566.929px",
    viewBox: "0 0 566.929 566.929",
    enableBackground: "new 0 0 566.929 566.929",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 12.9376,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M148.223,189.415c50.577-81.961,197.845-80.631,248.113,0.927"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 12.9376,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M148.223,380.174c50.577,81.963,197.845,80.631,248.113-0.926"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 13.6464,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 18.385,185.563 99.529,176.957 68.793,104.418 147.479,121.631 142.004,41.715 205.264,85.976 224.936,12.462 271.655,72.452  318.375,12.462 342.851,82.288 404.438,41.715 401.979,120.401 478.206,106.877 448.699,172.039 523.697,183.104  "
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#231F20",
    strokeWidth: 13.6464,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 18.385,381.365 99.529,389.973 68.793,462.512 147.479,445.297 142.004,525.213 205.264,480.953 224.936,554.467 271.655,494.477  318.375,554.467 342.851,484.641 404.438,525.213 401.979,446.527 478.206,460.053 448.699,394.889 523.697,383.824  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#010202",
    d: "M88.051,334.307H22.313l-2.453-2.453v-8.503l2.78-2.453v-68.191l2.453-2.453h49.713l15.699,15.535v66.229 L88.051,334.307z M76.931,270.694l-7.359-7.358h-33.36v57.889h40.719V270.694z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010202",
    d: "M135.312,297.022h-8.831l-2.289-2.29v-31.396h-14.881l-2.453-2.453v-8.176l2.616-2.453h25.837l2.453,2.453 v42.026L135.312,297.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010202",
    d: "M182.57,297.022h-8.831l-2.289-2.29v-31.396h-14.881l-2.453-2.453v-8.176l2.616-2.453h25.837l2.453,2.453 v42.026L182.57,297.022z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010202",
    d: "M273.327,334.307h-32.542l-2.453-2.453v-8.176l2.453-2.453h21.259v-50.53l-7.359-7.358h-24.202 l-11.61,70.808l-2.617,1.962l-8.667-1.636l-1.962-2.779l11.938-68.354h-12.101l-2.453-2.453v-8.176l2.616-2.453h54.292 l15.699,15.535v57.889v8.34C273.327,334.47,273.327,334.307,273.327,334.307z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010202",
    d: "M376.677,316.482l-14.063,15.044l-53.801,6.705l-2.943-2.289l-11.283-82.418l2.126-2.78l8.667-1.308 l2.616,2.125l9.812,73.261l38.756-4.742l7.032-7.85l10.302-60.669l2.617-2.125l8.83,1.308l1.799,3.107L376.677,316.482z  M342.99,310.595l-3.107,1.309l-7.522-2.616l-1.308-3.271l2.126-8.341v-44.969l2.452-2.453h8.831l2.289,2.453v48.077 L342.99,310.595z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010202",
    d: "M423.772,334.307h-8.994l-2.289-2.289v-68.682h-8.994l-2.453-2.453v-8.176l2.616-2.453h20.114l2.289,2.453 v79.311L423.772,334.307z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010202",
    d: "M496.705,334.307h-8.831l-2.289-2.289v-61.323l-7.359-7.358h-34.014l-2.453-2.453v-8.176l2.617-2.453 h39.083l15.535,15.535v66.229L496.705,334.307z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#010202",
    d: "M543.965,297.022h-8.831l-2.289-2.29v-31.396h-14.881l-2.453-2.453v-8.176l2.616-2.453h25.838l2.452,2.453 v42.026L543.965,297.022z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c97dde42878db97c9fcd41dd469e4a84.svg";
export { ForwardRef as ReactComponent };